"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionLabelSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../SearchPreviewProductSkeleton/styles");
var _constants = require("./constants");
const SectionLabelSkeleton = exports.SectionLabelSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)({
  height: _constants.SECTION_LABEL_HEIGHT,
  width: _constants.SECTION_LABEL_WIDTH
});
